// src/App.js
import React, { useState } from "react";
import "./App.css";

function App() {
  const whatsappNumberFull = "919110308773"; // 91 + 9110308773

  const [formData, setFormData] = useState({
    name: "",
    dob: "",
    tob: "",
    pob: "",
    concern: "",
    mode: "WhatsApp Call",
  });

  const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleWhatsAppSubmit = (e) => {
    e.preventDefault();

    const message = `
New Astrology Consultation Request

Name: ${formData.name}
Date of Birth: ${formData.dob}
Time of Birth: ${formData.tob}
Place of Birth: ${formData.pob}

Preferred Mode: ${formData.mode}
Concern / Question:
${formData.concern}
    `.trim();

    const url = `https://wa.me/${whatsappNumberFull}?text=${encodeURIComponent(
      message
    )}`;

    window.open(url, "_blank");
  };

  const directWhatsAppLink = `https://wa.me/${whatsappNumberFull}`;

  return (
    <div className="app">
      {/* NAVBAR */}
      <header className="navbar">
        <div
          className="navbar-logo"
          onClick={() => scrollToSection("home")}
          style={{ cursor: "pointer" }}
        >
          <div className="logo-circle">
            <span className="logo-symbol">★</span>
          </div>
          <div className="logo-text">
            <span className="brand-main">Modern Vedic Astrology</span>
            <span className="brand-sub">by Dr. Tejaswini</span>
          </div>
        </div>
        <nav className="navbar-links">
          <button onClick={() => scrollToSection("home")}>Home</button>
          <button onClick={() => scrollToSection("about")}>About</button>
          <button onClick={() => scrollToSection("services")}>Services</button>
          <button onClick={() => scrollToSection("how-it-works")}>
            How It Works
          </button>
          <button onClick={() => scrollToSection("blog")}>Blog</button>
          <button onClick={() => scrollToSection("resources")}>
            Free Resources
          </button>
          <button onClick={() => scrollToSection("contact")}>Contact</button>
        </nav>
      </header>

      {/* HERO SECTION */}
      <section id="home" className="hero fade-in">
        <div className="hero-left">
          <p className="hero-tag">Vishakha Nakshatra • Modern Vedic Approach</p>
          <h1>
            Clarity through{" "}
            <span className="highlight">Modern Vedic Astrology</span> with
            Dr. Tejaswini
          </h1>
          <p className="hero-subtitle">
            Intuitive, grounded birth chart readings for{" "}
            <b>life, career, emotions and decisions</b> – without fear-based
            predictions.
          </p>
          <div className="hero-buttons">
            <a
              href={directWhatsAppLink}
              target="_blank"
              rel="noreferrer"
              className="btn primary"
            >
              Book on WhatsApp
            </a>
            <button
              className="btn secondary"
              onClick={() => scrollToSection("services")}
            >
              View Services
            </button>
          </div>
          <p className="hero-note">
            1:1 sessions via <b>WhatsApp audio call</b> or{" "}
            <b>Google Meet video consultation</b>.
          </p>
        </div>
        <div className="hero-right">
          <div className="profile-orbit">
            <div className="profile-circle">
              <span className="profile-initials">DT</span>
            </div>
            <div className="orbit-ring orbit-one"></div>
            <div className="orbit-ring orbit-two"></div>
            <div className="orbit-dot orbit-dot-1"></div>
            <div className="orbit-dot orbit-dot-2"></div>
          </div>
          <div className="astro-mini-card">
            <h2>Birth Chart Insight</h2>
            <ul>
              <li>Vishakha Nakshatra–based intuitive reading</li>
              <li>Blend of Vedic rules & modern psychology</li>
              <li>Clear direction for the next steps in life</li>
            </ul>
          </div>
        </div>
      </section>

      {/* ABOUT SECTION */}
      <section id="about" className="section about fade-in">
        <div className="section-header">
          <h2>About Dr. Tejaswini</h2>
          <div className="section-line" />
        </div>
        <div className="about-content">
          <div className="about-text">
            <p>
              Dr. Tejaswini Bathala is a{" "}
              <b>Modern Vedic Astrologer</b> who combines classical Vedic
              wisdom with a grounded, psychological and practical approach.
              Being a <b>Vishakha Nakshatra</b> native, her readings are sharp,
              intuitive and deeply transformative.
            </p>
            <p>
              With a strong background in healthcare and research, she views
              every birth chart like a diagnostic map – decoding{" "}
              <b>
                patterns, emotional blocks, life themes and turning points
              </b>{" "}
              with clarity.
            </p>
            <p>Her sessions focus on:</p>
            <ul>
              <li>
                Helping you understand <b>who you really are at your core</b>
              </li>
              <li>
                Aligning your <b>career, choices and lifestyle</b> with your
                chart
              </li>
              <li>
                Offering <b>simple, practical remedies</b> and mindset shifts
              </li>
              <li>
                Creating a <b>safe, confidential space</b> to talk openly
              </li>
            </ul>
            <p>
              You won’t hear superstitious or fear-based statements in her
              readings. Instead, you receive{" "}
              <b>honest, empathetic and empowering guidance</b> you can act on.
            </p>
          </div>
        </div>
      </section>

      {/* SERVICES SECTION */}
      <section id="services" className="section services fade-in">
        <div className="section-header">
          <h2>Consultation Services</h2>
          <div className="section-line" />
          <p className="section-subtitle">
            All readings are done personally by Dr. Tejaswini via{" "}
            <b>WhatsApp audio call</b> or{" "}
            <b>Google Meet video consultation</b>.
          </p>
        </div>

        <div className="cards-grid">
          <div className="card">
            <h3>Basic Birth Chart Reading</h3>
            <p className="price">₹499</p>
            <ul>
              <li>Lagna, Sun & Moon sign analysis</li>
              <li>Core personality & life themes</li>
              <li>Key strengths to build on</li>
              <li>Areas needing gentle attention</li>
            </ul>
            <a
              href={directWhatsAppLink}
              target="_blank"
              rel="noreferrer"
              className="btn small primary"
            >
              Book this Session
            </a>
          </div>

          <div className="card">
            <h3>Deep-Dive Chart Analysis</h3>
            <p className="price">₹999</p>
            <ul>
              <li>Detailed house & planet placement reading</li>
              <li>Vishakha Nakshatra–based interpretation</li>
              <li>Patterns, cycles & emotional wiring</li>
              <li>Guidance for the next 6–12 months</li>
            </ul>
            <a
              href={directWhatsAppLink}
              target="_blank"
              rel="noreferrer"
              className="btn small primary"
            >
              Book this Session
            </a>
          </div>

          <div className="card">
            <h3>Career & Life Path Guidance</h3>
            <p className="price">₹1499</p>
            <ul>
              <li>Career direction & suitable roles</li>
              <li>Job change, stagnation & growth analysis</li>
              <li>Foreign opportunities & movement tendencies</li>
              <li>Support for major life decisions</li>
            </ul>
            <a
              href={directWhatsAppLink}
              target="_blank"
              rel="noreferrer"
              className="btn small primary"
            >
              Book this Session
            </a>
          </div>

          <div className="card">
            <h3>Emotional & Energy Insight</h3>
            <p className="price">₹1999</p>
            <ul>
              <li>Subconscious patterns & emotional loops</li>
              <li>Stress, burnout & overthinking tendencies</li>
              <li>Boundaries, energy leaks & self-worth</li>
              <li>Simple lifestyle & mindset remedies</li>
            </ul>
            <a
              href={directWhatsAppLink}
              target="_blank"
              rel="noreferrer"
              className="btn small primary"
            >
              Book this Session
            </a>
          </div>

          <div className="card highlight-card">
            <h3>Premium All-in-One Reading</h3>
            <p className="price">₹2499</p>
            <ul>
              <li>Complete birth chart decoding</li>
              <li>Life direction + emotional map</li>
              <li>Career & decision guidance</li>
              <li>Remedies + 1 follow-up within 30 days</li>
            </ul>
            <a
              href={directWhatsAppLink}
              target="_blank"
              rel="noreferrer"
              className="btn small primary"
            >
              Book Premium Session
            </a>
          </div>
        </div>
      </section>

      {/* HOW IT WORKS */}
      <section
        id="how-it-works"
        className="section how fade-in"
      >
        <div className="section-header">
          <h2>How the Consultation Works</h2>
          <div className="section-line" />
        </div>
        <div className="steps-grid">
          <div className="step-card">
            <span className="step-number">1</span>
            <h4>Send Your Details</h4>
            <p>
              Message on WhatsApp with your{" "}
              <b>
                Name, Date of Birth, Time of Birth, Place of Birth
              </b>{" "}
              and a short note about your concern.
            </p>
          </div>
          <div className="step-card">
            <span className="step-number">2</span>
            <h4>Choose Mode & Slot</h4>
            <p>
              You’ll receive available time slots and can choose{" "}
              <b>WhatsApp audio call</b> or{" "}
              <b>Google Meet video consultation</b>.
            </p>
          </div>
          <div className="step-card">
            <span className="step-number">3</span>
            <h4>Confirm with Payment</h4>
            <p>
              Make the payment using the details shared on WhatsApp.
              Once confirmed, your slot is reserved.
            </p>
          </div>
          <div className="step-card">
            <span className="step-number">4</span>
            <h4>1:1 Personal Session</h4>
            <p>
              During the session, your chart is decoded in detail with
              time for your questions, clarifications and real-time
              guidance.
            </p>
          </div>
        </div>
      </section>

      {/* BLOG SECTION */}
      <section id="blog" className="section blog fade-in">
        <div className="section-header">
          <h2>Blog: Astrology & Self-Discovery</h2>
          <div className="section-line" />
        </div>

        <div className="cards-grid">
          <div className="card soft-card">
            <h3>Vishakha Nakshatra: The Power of Focus & Transformation</h3>
            <p className="blog-snippet">
              Vishakha is about goals, intensity and the willingness to
              transform. If you keep attracting big turning points in life,
              your chart may be asking you to grow instead of settle...
            </p>
            <p className="blog-note">
              (This blog can be expanded later as a full article.)
            </p>
          </div>
          <div className="card soft-card">
            <h3>Why Your Moon Sign Affects Your Emotions More Than Your Sun Sign</h3>
            <p className="blog-snippet">
              In Vedic astrology, your Moon sign represents your emotional
              wiring—how you feel, react and attach. Understanding it can
              shift how you handle relationships and stress...
            </p>
          </div>
          <div className="card soft-card">
            <h3>Using Astrology as a Decision Support Tool, Not a Fear Tool</h3>
            <p className="blog-snippet">
              Astrology is not meant to scare you or limit you. When done
              consciously, it becomes a support system that helps you make
              better aligned decisions rather than surrendering your power...
            </p>
          </div>
        </div>
      </section>

      {/* FREE RESOURCES */}
      <section
        id="resources"
        className="section resources fade-in"
      >
        <div className="section-header">
          <h2>Free Resources</h2>
          <div className="section-line" />
          <p className="section-subtitle">
            Simple tools you can start using before or after your session.
          </p>
        </div>

        <div className="resources-grid">
          <div className="resource-card">
            <h3>Daily Check-In Prompt</h3>
            <p>
              Every night, ask yourself: <b>“What did I feel most today?”</b>{" "}
              and <b>“Where did I feel drained?”</b>  
              Over time, this reveals emotional patterns that your chart confirms.
            </p>
          </div>
          <div className="resource-card">
            <h3>Moon Sign Emotional Reminder</h3>
            <p>
              Your Moon sign shows <b>how you need to be cared for</b>.  
              Give yourself the same emotional support you keep expecting
              from others.
            </p>
          </div>
          <div className="resource-card">
            <h3>Pre-Session Reflection Sheet</h3>
            <p>
              Before booking, note down:  
              1) What is confusing me right now?  
              2) What do I want clarity on in the next 6–12 months?  
              3) What patterns keep repeating?  
              Bring these to the session.
            </p>
          </div>
        </div>
      </section>

      {/* TESTIMONIALS */}
      <section
        id="testimonials"
        className="section testimonials fade-in"
      >
        <div className="section-header">
          <h2>What Clients Experience</h2>
          <div className="section-line" />
        </div>
        <div className="cards-grid">
          <div className="card soft-card">
            <p>
              “The reading was extremely accurate. It felt like she was
              describing my inner world better than I could. Very grounding
              and practical.”
            </p>
            <span className="client-name">— Client, Career Reading</span>
          </div>
          <div className="card soft-card">
            <p>
              “No drama, no fear – just pure clarity. I left with a clear idea
              of what to focus on this year and what to stop worrying about.”
            </p>
            <span className="client-name">
              — Client, Deep-Dive Chart Analysis
            </span>
          </div>
          <div className="card soft-card">
            <p>
              “She connected emotional patterns with my chart so beautifully.
              The remedies were simple and doable, not superstitious.”
            </p>
            <span className="client-name">
              — Client, Emotional Insight Session
            </span>
          </div>
        </div>
      </section>

      {/* CONTACT / WHATSAPP FORM */}
      <section
        id="contact"
        className="section contact fade-in"
      >
        <div className="section-header">
          <h2>Book a Session</h2>
          <div className="section-line" />
        </div>

        <div className="contact-grid">
          <div className="contact-text">
            <p>
              Ready for an honest, intuitive and practical reading of your
              chart? You can either <b>message directly on WhatsApp</b> or
              use the form here to create a pre-filled WhatsApp message.
            </p>
            <p>
              <b>WhatsApp:</b>{" "}
              <a
                href={directWhatsAppLink}
                target="_blank"
                rel="noreferrer"
              >
                9110308773
              </a>
              <br />
              <b>Email:</b>{" "}
              <a href="mailto:drtejaswinibathala@gmail.com">
                drtejaswinibathala@gmail.com
              </a>
              <br />
              <b>Instagram:</b>{" "}
              <a
                href="https://instagram.com/itsme_.teja"
                target="_blank"
                rel="noreferrer"
              >
                @itsme_.teja
              </a>
            </p>
            <p className="contact-note">
              Consultations are confidential. Personal details and chats are
              never shared without consent.
            </p>
          </div>

          <div className="contact-form-card">
            <h3>Quick Booking Form</h3>
            <form onSubmit={handleWhatsAppSubmit} className="contact-form">
              <div className="form-row">
                <label>
                  Name
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </label>
              </div>
              <div className="form-row two-col">
                <label>
                  Date of Birth
                  <input
                    type="text"
                    name="dob"
                    placeholder="DD-MM-YYYY"
                    value={formData.dob}
                    onChange={handleChange}
                    required
                  />
                </label>
                <label>
                  Time of Birth
                  <input
                    type="text"
                    name="tob"
                    placeholder="HH:MM (AM/PM)"
                    value={formData.tob}
                    onChange={handleChange}
                    required
                  />
                </label>
              </div>
              <div className="form-row">
                <label>
                  Place of Birth
                  <input
                    type="text"
                    name="pob"
                    value={formData.pob}
                    onChange={handleChange}
                    required
                  />
                </label>
              </div>
              <div className="form-row">
                <label>
                  Preferred Mode
                  <select
                    name="mode"
                    value={formData.mode}
                    onChange={handleChange}
                  >
                    <option>WhatsApp Call</option>
                    <option>Google Meet Video Call</option>
                  </select>
                </label>
              </div>
              <div className="form-row">
                <label>
                  Main Concern / Question
                  <textarea
                    name="concern"
                    rows="3"
                    value={formData.concern}
                    onChange={handleChange}
                    required
                  />
                </label>
              </div>
              <button type="submit" className="btn primary full-width">
                Open WhatsApp with My Details
              </button>
            </form>
          </div>
        </div>

        <footer className="footer">
          <p>
            © {new Date().getFullYear()} Modern Vedic Astrology by Dr.
            Tejaswini. All rights reserved.
          </p>
        </footer>
      </section>
    </div>
  );
}

export default App;
